// extracted by mini-css-extract-plugin
module.exports = {"genericForm":"style_genericForm__Ym18B","btnWidth":"style_btnWidth__43HjD"};